import { Container, Graphics, Sprite } from "pixi.js";
import type { Texture } from "pixi.js";
import type { WorldSnapshot } from "@frontier/protocol/contracts";
interface LootView {
  sprite: Sprite;
  ring: Graphics;
}
export class LootViews {
  readonly container = new Container();
  private readonly views = new Map<string, LootView>();
  constructor(private readonly texture: Texture) {}
  update(snapshot: WorldSnapshot, playerId: string): void {
    const loot = snapshot.loot.filter(
      (item) => !item.claimedBy.includes(playerId),
    );
    const ids = new Set(loot.map((item) => item.id));
    for (const [id, view] of this.views)
      if (!ids.has(id)) {
        view.sprite.destroy();
        view.ring.destroy();
        this.views.delete(id);
      }
    for (const item of loot) {
      let view = this.views.get(item.id);
      if (!view) {
        const sprite = new Sprite({ texture: this.texture, anchor: 0.5 });
        sprite.width = item.kind === "contraband" ? 35 : 28;
        sprite.scale.y = sprite.scale.x;
        view = { sprite, ring: new Graphics() };
        this.views.set(item.id, view);
        this.container.addChild(view.ring, sprite);
      }
      const color =
        item.kind === "contraband"
          ? 0xef94e6
          : (item.kind === "battery" || item.kind === "rocket" || item.kind === "drone")
            ? 0x9bbdf0
          : item.kind === "energy"
            ? 0x6deaf1
            : 0xffce6a;
      view.sprite.position.set(item.x, item.y);
      view.sprite.tint = color;
      view.sprite.alpha = item.pending ? 0.35 : 1;
      view.ring
        .clear()
        .circle(item.x, item.y, item.shared ? 30 : 25)
        .fill({ color, alpha: 0.05 })
        .stroke({ color, width: item.shared ? 2 : 1, alpha: 0.55 });
      if (item.shared)
        view.ring
          .poly([
            item.x,
            item.y - 38,
            item.x + 38,
            item.y,
            item.x,
            item.y + 38,
            item.x - 38,
            item.y,
          ])
          .stroke({ color, width: 1, alpha: 0.5 });
    }
  }
}
